import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Logo from "../../components/Logo";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) {
    navigate("/admin", { replace: true });
    return null;
  }

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="min-h-screen bg-blush flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-white border border-gold/20 p-10 md:p-12 shadow-[0_30px_80px_rgba(184,151,66,0.12)]">
        <Logo />
        <h1 className="mt-8 font-display text-3xl text-ink">Editorial CMS</h1>
        <p className="mt-2 text-sm text-neutral-500">Sign in to manage stories, pages and the home page.</p>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label htmlFor="admin-email" className="block text-[10px] uppercase tracking-[0.25em] text-gold font-semibold mb-2">Email</label>
            <input
              id="admin-email"
              data-testid="admin-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-ink/15 px-4 py-3 text-sm outline-none focus:border-gold transition-colors duration-300"
              placeholder="admin@thebridesofindia.co"
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="block text-[10px] uppercase tracking-[0.25em] text-gold font-semibold mb-2">Password</label>
            <input
              id="admin-password"
              data-testid="admin-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-ink/15 px-4 py-3 text-sm outline-none focus:border-gold transition-colors duration-300"
              placeholder="Your password"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-red-600">{error}</p>
          )}
          <button
            type="submit"
            data-testid="admin-login-button"
            disabled={busy}
            className="w-full bg-ink text-cream py-3.5 text-xs uppercase tracking-[0.3em] font-semibold hover:bg-gold transition-colors duration-300 disabled:opacity-50"
          >
            {busy ? "Signing in" : "Sign In"}
          </button>
        </form>
      </div>
    </main>
  );
}
